export default "/_next/static/fonts/tt_norms_pro_medium_italic-7a546b59baf8012e5b255d1671927665.woff";